import styled from 'styled-components';
import { StyledHeaderTitleWrapper } from './TitleWrapper';
import { StyledHeaderSubtitleWrapper } from './SubtitleWrapper';
import { StyledHeaderLeftWrapper } from './LeftWrapper';
import { StyledHeaderRightWrapper } from './RightWrapper';

export const StyledHeaderContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 0.8fr 4fr auto 4fr 0.8fr;
  grid-template-rows: 1fr 1fr;
  grid-auto-flow: column;
  gap: 0;
  height: 50px;
  width: 100%;
  grid-template-areas:
    '. left title right .'
    '. left subtitle right .';
  overflow: hidden;
  text-overflow: ellipsis;
  align-content: center;

  ${StyledHeaderTitleWrapper} {
    grid-area: title;
    align-self: center;
    justify-self: center;
  }

  ${StyledHeaderSubtitleWrapper} {
    grid-area: subtitle;
    align-self: center;
    justify-self: center;
  }

  ${StyledHeaderLeftWrapper} {
    grid-area: left;
    align-self: center;
    justify-self: center;

    .home-button {
      grid-area: home-button;
      align-self: center;
      justify-self: flex-start;
    }
  }

  ${StyledHeaderRightWrapper} {
    grid-area: right;
    align-self: center;
    justify-self: center;

    .sync-button {
      grid-area: sync-button;
      align-self: center;
      justify-self: flex-end;
    }
  }
`;
